import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/portfolio/vision-quality-control/page.tsx");
